<ngx-spinner *ngIf="hideSpinner != false" bdColor="rgba(100,112,124,0.56)" size="medium" color="#233547"
  type="ball-clip-rotate-multiple" [fullScreen]="true">
  <p style="color: white"> </p>
</ngx-spinner>
<div class="menu-large">
  <div class="container-fluid">
    <div class="row elhoo_dashboardMenu_menuPosition pt-5 fixedPosiion ">
        <div class="col-12 col-md-12 pt-5">
          <div class="header__logo">
            <img routerLink="/user/vehicule" src="assets/icons/logo.svg" style="margin-left: 12px;" width="31px" height="40" alt="" loading="lazy" />
          </div>
          <div  routerLink="/user/vehicule" placement="right" ngbTooltip="Statistique des véhicules"  (click)="RedirectGo('/user/vehicule')"
           class="elhoo_dashboardMenu_IconSvgStyle"
           [ngClass]="{elhoo_dashboardMenu_IconSvgShadow_on: linkSelected == '/user/vehicule' ||  linkSelected == '/user/vehicule/details/'+urlSelectionner
           ||  linkSelected == '/user/vehicule/trajet/'+urlSelectionner     }">
          <a [ngClass]="{BtnLinkActive:  linkSelected == '/user/vehicule' ||  linkSelected == '/user/vehicule/details/'+urlSelectionner
           ||  linkSelected == '/user/vehicule/trajet/'+urlSelectionner  }">
            <img
              src="{{linkSelected == '/user/vehicule' ? 'assets/icons/vehicule-red.svg' : 'assets/icons/11-01.svg' }}"
              [ngClass]="{dashboardMenu_IconSvgShadow_on: linkSelected == '/user/vehicule' }" />
          </a>
        </div>
        <div routerLink="/user/conducteur" placement="right" ngbTooltip="Statistique des conducteurs"
          (click)="RedirectGo('/user/conducteur')" class="elhoo_dashboardMenu_IconSvgStyle" [ngClass]="{elhoo_dashboardMenu_IconSvgShadow_on: linkSelected == '/user/conducteur' ||  linkSelected == '/user/conducteur/details/'+urlSelectionner
           ||  linkSelected == '/user/conducteur/trajet/'+urlSelectionner }">
          <a [ngClass]="{BtnLinkActive: linkSelected == '/user/conducteur' || linkSelected == '/user/conducteur/details/'+urlSelectionner
           ||  linkSelected == '/user/conducteur/trajet/'+urlSelectionner  }">
            <img
              src="{{ linkSelected == '/user/conducteur' ? 'assets/icons/conducteur-red.svg' : 'assets/icons/group.svg' }}"
              [ngClass]="{dashboardMenu_IconSvgShadow_on: linkSelected == '/user/conducteur' ||  linkSelected == '/user/conducteur/details/'+urlSelectionner
             ||  linkSelected == '/user/conducteur/trajet/'+urlSelectionner }" />
          </a>
        </div>


        <div  routerLink="/user/listvehicule" placement="right" ngbTooltip="Gestion des véhicules"  (click)="RedirectGo('/user/listvehicule')"
        class="elhoo_dashboardMenu_IconSvgStyle"
        [ngClass]="{elhoo_dashboardMenu_IconSvgShadow_on: linkSelected == '/user/listvehicule' }">
       <a [ngClass]="{BtnLinkActive:  linkSelected == '/user/listvehicule' }">
         <img
           src="{{linkSelected == '/user/listvehicule' ? 'assets/icons/vehicule-red.svg' : 'assets/icons/11-01.svg' }}"
           [ngClass]="{dashboardMenu_IconSvgShadow_on: linkSelected == '/user/listvehicule' }" />
       </a>
     </div>




        <div routerLink="/user/driverlistconducteur" placement="right" ngbTooltip="Gestion des conducteurs"
          (click)="RedirectGo('/user/driverlistconducteur')" class="elhoo_dashboardMenu_IconSvgStyle" [ngClass]="{elhoo_dashboardMenu_IconSvgShadow_on: linkSelected == '/user/driverlistconducteur'  }">
          <a [ngClass]="{BtnLinkActive: linkSelected == '/user/driverlistconducteur' }">
            <img
              src="{{ linkSelected == '/user/driverlistconducteur' ? 'assets/icons/conducteur-red.svg' : 'assets/icons/group.svg' }}"
              [ngClass]="{dashboardMenu_IconSvgShadow_on: linkSelected == '/user/driverlistconducteur' }" />
          </a>
        </div>
        <div routerLink="/user/contacts" placement="right" ngbTooltip="Contacts" (click)="RedirectGo('/user/contacts')"
          class="elhoo_dashboardMenu_IconSvgStyle" [ngClass]="{elhoo_dashboardMenu_IconSvgShadow_on: linkSelected == '/user/contacts' ,
                           elhoo_dashboardMenu_IconSvgShadow_off : linkSelected != '/user/contacts' }">
          <a [ngClass]="{BtnLinkActive: linkSelected == '/user/contacts' }">
            <img
              src=" {{ linkSelected == '/user/contacts' ? 'assets/icons/contact-red.svg' : 'assets/icons/contact.svg' }}"
              [ngClass]="{dashboardMenu_IconSvgShadow_on: linkSelected == '/user/conducteur' ||  linkSelected == '/user/conducteur/details/'+urlSelectionner
              ||  linkSelected == '/user/conducteur/trajet/'+urlSelectionner }" />
          </a>
        </div>
        <div routerLink="/user/events" placement="right" ngbTooltip="Evénements" (click)="RedirectGo('/user/events')"
          class="elhoo_dashboardMenu_IconSvgStyle" [ngClass]="{elhoo_dashboardMenu_IconSvgShadow_on: linkSelected == '/user/events' ,
                             elhoo_dashboardMenu_IconSvgShadow_off : linkSelected != '/user/events' }">
          <a [ngClass]="{BtnLinkActive: linkSelected == '/user/events' }">
            <img src="{{ linkSelected == '/user/events' ? ' assets/icons/event-red.svg' : 'assets/icons/event.svg' }}"
              [ngClass]="{dashboardMenu_IconSvgShadow_on: linkSelected == '/user/conducteur' ||  linkSelected == '/user/conducteur/details/'+urlSelectionner
                ||  linkSelected == '/user/conducteur/trajet/'+urlSelectionner }" />
          </a>
        </div>
        <div routerLink="/user/report" placement="right" ngbTooltip="Rapports" (click)="RedirectGo('/user/report')"
          class="elhoo_dashboardMenu_IconSvgStyle" [ngClass]="{elhoo_dashboardMenu_IconSvgShadow_on: linkSelected == '/user/report' || linkSelected == '/user/reportfavorite'
             || linkSelected == '/user/plannification' || linkSelected == '/user/reportHistory'   }">
          <a [ngClass]="{BtnLinkActive: linkSelected == '/user/report' || linkSelected == '/user/reportfavorite'
             || linkSelected == '/user/plannification' || linkSelected == '/user/reportHistory'  }">
            <img
              src=" {{ linkSelected == '/user/report' ? 'assets/icons/rapport-red.svg' : 'assets/icons/rapport.svg' }}"
              [ngClass]="{dashboardMenu_IconSvgShadow_on: linkSelected == '/user/conducteur' ||  linkSelected == '/user/conducteur/details/'+urlSelectionner
               ||  linkSelected == '/user/conducteur/trajet/'+urlSelectionner }" />
          </a>
        </div>
        <div routerLink="/user/alarm" placement="right" ngbTooltip="Configuration des alarmes"
          (click)="RedirectGo('/user/alarm')" class="elhoo_dashboardMenu_IconSvgStyle"
          [ngClass]="{elhoo_dashboardMenu_IconSvgShadow_on: linkSelected == '/user/alarm' || linkSelected == '/user/alarm/events' ||  linkSelected ==  '/user/alarm/accident'  }">
          <a
            [ngClass]="{BtnLinkActive: linkSelected == '/user/alarm' || linkSelected == '/user/alarm/events' ||  linkSelected ==  '/user/alarm/accident' }">
            <img src=" {{ linkSelected == '/user/alarm' ? 'assets/icons/alarm-red.svg' : 'assets/icons/alarm.svg' }}"
              [ngClass]="{dashboardMenu_IconSvgShadow_on: linkSelected == '/user/conducteur' ||  linkSelected == '/user/conducteur/details/'+urlSelectionner
                ||  linkSelected == '/user/conducteur/trajet/'+urlSelectionner }" />
          </a>
        </div>
        <div routerLink="/user/alarms/history" placement="right" ngbTooltip="Historique des alarmes"
          (click)="RedirectGo('/user/alarms/history')" class="elhoo_dashboardMenu_IconSvgStyle" [ngClass]="{elhoo_dashboardMenu_IconSvgShadow_on: linkSelected == '/user/alarms/history' ,
                             elhoo_dashboardMenu_IconSvgShadow_off : linkSelected != '/user/alarms/history' }">
          <a [ngClass]="{BtnLinkActive: linkSelected == '/user/alarms/history' }">
            <img
              src="{{ linkSelected == '/user/alarms/history' ? 'assets/icons/alarm-2-red.svg' : 'assets/icons/alarm-2.svg' }}"
              [ngClass]="{dashboardMenu_IconSvgShadow_on: linkSelected == '/user/conducteur' ||  linkSelected == '/user/conducteur/details/'+urlSelectionner
                ||  linkSelected == '/user/conducteur/trajet/'+urlSelectionner }" />
          </a>
        </div>
        <div routerLink="/user/preference" style="pointer-events: none;
    filter: brightness(0.9);display: none;" placement="right" ngbTooltip="Préferences"
          (click)="RedirectGo('preference')" class="elhoo_dashboardMenu_IconSvgStyle" [ngClass]="{elhoo_dashboardMenu_IconSvgShadow_on: linkSelected == 'preference' ,
                             elhoo_dashboardMenu_IconSvgShadow_off : linkSelected != 'preference' }">
          <a [ngClass]="{BtnLinkActive: linkSelected == 'preference' }">
            <i class="fa fa-asterisk fa-2x"
              [ngClass]="{dashboardMenu_IconSvgShadow_on: linkSelected == 'preference' }"></i>
          </a>
        </div>
        <div (click)="logout()" class="elhoo_dashboardMenu_helpIconSvgStyle fixed-bottom mb-4">
          <div placement="right" ngbTooltip="Se déconnecter" class="elhoo_dashboardMenu_IconSvgStyle">
            <a>
              <img src="assets/icons/deconect.svg">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
